// extracted by mini-css-extract-plugin
export default {"root":"n44B6JUp5Duf7RH_b9jP","label":"Hahg5EwFOvbvQYLOaDxL","placeHolderShimmer":"g4Jg3jicfQH7VG5DoMm3"};